import { render, staticRenderFns } from "./RubricDescriptorCell.vue?vue&type=template&id=cd44227a&scoped=true"
import script from "./RubricDescriptorCell.vue?vue&type=script&lang=js"
export * from "./RubricDescriptorCell.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=cd44227a&prod&scoped=true&lang=css&external"
import style1 from "./RubricDescriptorCell.vue?vue&type=style&index=1&id=cd44227a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd44227a",
  null
  
)

export default component.exports